import { useSelector } from 'react-redux';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import useAutobizTrade from '../../../config/Record/useAutobizTrade';
import { Auth } from '../../../config/configuration/react';
import { t, translateDate } from '../../../components/common/Translate';
import { autobizTradeSiteUrl } from '../../../config';
import { Record } from '../../../config/Record/RecordEntity';

export const useTrade = ({ recordId, tradeId, autobizTradeDate }) => {
  const { trade, isLoadingTrade, errorTrade } = useAutobizTrade(recordId, tradeId, autobizTradeDate);
  const history = useHistory();
  let appLang = (Cookies.get('appLanguage') || 'en').toLocaleLowerCase();
  if (appLang === null || appLang === undefined || appLang === 'var') appLang = 'fr';
  const record = useSelector((state) => state.reduxRecords.data[recordId]) || {};
  const recordEntity = new Record(record);
  const isVisible = recordEntity.tradeIsVisible();
  const active = Auth.isAllowedToAccessTrade() && isVisible;
  const { sale } = trade;
  const status = sale?.sale_status?.name ? sale.sale_status.name : null;
  const goToTrade = () => {
    if (!active) return;
    history.push({
      pathname: `/files/${recordId}/pushAt`,
      state: {
        ...history.location.state,
        tradeId: trade?.id || null,
      },
    });
  };

  const end_date_time = _.get(sale, 'end_date_time', null);
  const start_date_time = _.get(sale, 'start_date_time', null);
  const salesType = _.get(sale, 'salesType', null);

  const labels = [];

  if (!['INACTIVE', 'draft'].includes(status)) {
    if (start_date_time)
      labels.push({
        label: t('startDateTimeAuction'),
        value: translateDate(start_date_time, t('DD/MM/YYYY HH:mm')),
      });

    if (end_date_time)
      labels.push({
        label: t('endDateTimeAuction'),
        value: translateDate(end_date_time, t('DD/MM/YYYY HH:mm')),
      });

    if (salesType)
      labels.push({
        label: t('salesType'),
        value: t(salesType),
      });
  }

  const openAutobizTradeLink = () => {
    window.open(`${autobizTradeSiteUrl}/records/${sale.id}`, '_blank');
  };

  return {
    isLoadingTrade,
    errorTrade,
    goToTrade,
    openAutobizTradeLink,
    status,
    labels,
    active,
    isVisible,
    trade,
    pointOfSaleName: trade?.session_vehicle?.vehicle?.dealer?.name || null,
  };
};
